import { InlineLoading } from "@carbon/react";
import {
  Badge,
  CopyButton,
  LeftRightFlexedContainer,
  ModalContainer,
  ModalSectionTitle,
  SectionHeader,
  Select,
  SkeletonLoader,
  SwitchAppButton,
} from "../../../components";
import { IManageTeamMemberFormViewProps } from "./ManageTeamMember";
import { ManageTeamMemberTransferLimits } from "./ManageTeamMemberTransferLimit";

export const View = ({
  isModalOpen,
  closeModal,

  // userAccessClaimsFieldArray,
  setClaimToAdd,
  setClaimToRemove,
  claimToAdd,
  claimToRemove,
  appendAccessClaimToUser,
  // removeAccessClaimFromUser,
  isSubmittingAppendClaimToUser,
  isSubmittingRemoveClaimFromUser,
  isLoadingModalData,
  teamMember,

  // values used for settings form
  isLoadingAvailableAccessClaims,
  isErrorAvailableAccessClaims,
  availableAccessClaims,
}: IManageTeamMemberFormViewProps) => {
  return (
    <ModalContainer
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      modalHeader={
        <SectionHeader
          title={`Manage Your Team Members`}
          subtitle="Grant or limit access to your team on SwitchApp."
        />
      }
    >
      <div className="manage-team-member--container">
        <div className="user-details--container pt-5">
          {/* <ModalSectionTitle key_id="User Details" noTopMargin noBottomBorder /> */}

          <LeftRightFlexedContainer
            key_id="User"
            value={
              <div className="flex-container justify-content--start align-items--center">
                {isLoadingModalData ? (
                  <SkeletonLoader
                    type="text"
                    className="user-details--skeleton"
                  />
                ) : (
                  <span title={teamMember?.full_name}>
                    {teamMember?.full_name}
                  </span>
                )}
              </div>
            }
          />

          <LeftRightFlexedContainer
            key_id="Email"
            value={
              isLoadingModalData ? (
                <SkeletonLoader
                  type="text"
                  className="user-details--skeleton"
                />
              ) : (
                <div className="flex-container justify-content--start align-items--center">
                  <span title={teamMember?.email}>{teamMember?.email}</span>
                  {teamMember?.email && (
                    <div className="copy-button--container ml-5">
                      <CopyButton
                        stringToCopy={teamMember?.email}
                        iconDescription="copy Email"
                        className="copy-btn"
                      />
                    </div>
                  )}
                </div>
              )
            }
          />

          {/* <LeftRightFlexedContainer
            key_id="Last Login"
            value={
              <div className="flex-container justify-content--start align-items--center">
                <span title={teamMember?.last_login_date}>{teamMember?.last_login_date}</span>
              </div>
            }
          /> */}
        </div>

        <div className="manage-user-access--container">
          <ModalSectionTitle key_id="Manage User Access" />

          <div className="flex-container justify-content--between align-items--end mt-5">
            <div className="flex-box">
              <Select
                name="availableAccessClaimsSelectHelper"
                label="Add User To Role"
                infoIconText="Your team member will have this role in your organization."
                placeholder="Please select a role"
                showSkeleton={isLoadingAvailableAccessClaims}
                selectItems={[]}
                selectGroupedItems={[
                  {
                    groupLabel: ``,
                    options: [
                      {
                        text: "SELECT A ROLE",
                        value: "", // placeholder to escape first item selection bug
                      },
                    ],
                  },
                  ...availableAccessClaims.map((claim) => ({
                    groupLabel: `${claim.description}`,
                    options: [
                      {
                        text: claim.claim,
                        value: claim.claim,
                      },
                    ],
                  })),
                ]}
                onChange={(e) => setClaimToAdd(e.target?.value ?? null)}
              />
            </div>

            <div className="flex-box">
              <SwitchAppButton
                size="sm"
                kind={"primary"}
                className="mt-5 ml-5 mr-5 pl-5 pr-5"
                isLoading={isSubmittingAppendClaimToUser}
                disabled={!claimToAdd || availableAccessClaims.length < 1}
                onClick={appendAccessClaimToUser} // NOTE: necessary to ignore post-data BUG from POST & PUT methods in useQuickSubmitFormHelper()
              >
                Add User To Role
              </SwitchAppButton>
            </div>
          </div>

          <div className="mt-5">
            <strong className="mr-5">Current Roles:</strong>

            {isLoadingModalData ? (
              <div className="flex-container">
                <SkeletonLoader
                  type="text"
                  className="user-role--skeleton flex-box mr-5"
                />
                <SkeletonLoader
                  type="text"
                  className="user-role--skeleton flex-box mr-5"
                />
                <SkeletonLoader
                  type="text"
                  className="user-role--skeleton flex-box"
                />
              </div>
            ) : (
              <div className="flex-container">
                {teamMember?.user_access_claims?.map((claim, index) => (
                  <div
                    className="mr-5 cursor-pointer"
                    title="Click to remove role"
                    onClick={() => setClaimToRemove(claim)}
                  >
                    <Badge
                      text={claim}
                      statusColor={
                        claim.toLowerCase().includes("owner")
                          ? "teal"
                          : claim.toLowerCase().includes("admin")
                          ? "primary"
                          : "warning"
                      }
                      className="pl-5 mt-5"
                      indicatorComponent={
                        isSubmittingRemoveClaimFromUser &&
                        claimToRemove === claim ? (
                          <div className="pl-5">
                            <InlineLoading description="" />
                          </div>
                        ) : (
                          <span className="pl-5 text-danger font-ctm--bold">
                            &times;
                          </span>
                        )
                      }
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {!teamMember ? null : (
          <ManageTeamMemberTransferLimits teamMember={teamMember} />
        )}
      </div>
    </ModalContainer>
  );
};
